import { useQuery } from '@tanstack/react-query';
import { geocodingApi } from '@/lib/api/endpoints';

/** ~11 m, matching the server's cache key, so the two agree on what is "here". */
const PRECISION = 4;

/**
 * The place name for a coordinate, looked up only while something is on screen
 * that shows it. Keyed on the rounded pair so a vehicle creeping around a yard
 * does not refetch on every position update.
 */
export function useReverseGeocode(lat?: number, lng?: number) {
  const hasPoint = typeof lat === 'number' && typeof lng === 'number';
  const key = hasPoint ? [lat.toFixed(PRECISION), lng.toFixed(PRECISION)] : [];

  return useQuery({
    queryKey: ['geocode', 'reverse', ...key],
    queryFn: () => geocodingApi.reverse(lat as number, lng as number),
    enabled: hasPoint,
    // Place names do not change; the server caches for months, so re-asking
    // within a session is pure waste.
    staleTime: Infinity,
    gcTime: 60 * 60_000,
    retry: false,
    select: (data) => data.place,
  });
}
